import StudentResultOverview from "../StudentResultOverview";
import ClassResultOverview from "../ClassResultOverview";
import ProgramResultOverview from "../ProgramResultOverview";

export default function TeacherResultOverview({
  level,
  classCoursesData,
  classData,
  student,
  studentId,
  studentHasLicense,
  coursesData,
  coursesWithResults,
}) {
  const renderLevel = () => {
    switch (level) {
      case "Class":
        return (
          <div>
            <ClassResultOverview
              classCoursesData={classCoursesData}
              classData={classData}
            />
          </div>
        );
      case "Student":
        if (studentHasLicense) {
          return (
            <StudentResultOverview
              studentEmail={student.email}
              studentId={studentId}
              coursesWithResults={coursesWithResults}
            />
          );
        } else {
          return (
            <div>
              Eleven har inga licenser och därmed inga resultat att visa.
            </div>
          );
        }
      case "Program":
        return <ProgramResultOverview coursesData={coursesData} />;

      default:
        return <div></div>;
    }
  };

  return <div>{renderLevel()}</div>;
}
